import { forwardRef, useEffect, useState } from "react";
import RouteMap from "../../Map/RouteMap";

const RouteInput = forwardRef((props, ref) => {

    let [value, updateValue] = useState(props.value);

    const handleChange = newValue => {
        const elementObj = {
            target: {
                name: props.name,
                value: newValue
            }
        }

        updateValue(newValue);
        props.onChange(elementObj);
    };

    useEffect(() => {
        updateValue(props.value)
    }, [props.value]);

    const inputProps = {
        id: `id_${props.name}`,
        onChange: handleChange,
        name: props.name,
    }

    return (
        <div>
            <RouteMap {...inputProps} pointA={props.pointA} pointB={props.pointB} />
        </div>
    );
})
export default RouteInput;
